import { render, staticRenderFns } from "./EmojiPickerInput.vue?vue&type=template&id=b4ddc8cc&scoped=true&"
import script from "./EmojiPickerInput.vue?vue&type=script&lang=ts&"
export * from "./EmojiPickerInput.vue?vue&type=script&lang=ts&"
import style0 from "./EmojiPickerInput.vue?vue&type=style&index=0&id=b4ddc8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ddc8cc",
  null
  
)

export default component.exports